import { render, staticRenderFns } from "./Pendings.vue?vue&type=template&id=5dec7099&"
import script from "./Pendings.vue?vue&type=script&lang=js&"
export * from "./Pendings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports